
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  *
  * The source file is located at:
  *   /codebuild/output/src1738611268/src/vl-app/pages/patients/assessments.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import React, { /*useEffect, */ useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from '@hooks/useRouter';
import { getAssessmentSurvey } from '@actions';
import { useInitialisedStore } from '@hooks/useInitialisedStore';
import useAuth from '@vl-core/useAuth';
import styled from '@emotion/styled';
// import { css } from '@emotion/react';
// import useNeedCardDetails from '@hooks/useNeedCardDetails';
import { useArticleWrapped } from '@hooks/useArticleWrapped';
import useCase from '@hooks/useCase';
import * as actions from '@actions';
import CookieSettings from '@components/CookieConsent/CookieSettings';
import { GetDocmanConsentForm } from '@components/Patients/Docman/MaybeGetDocmanConsent';
import { isSurveyPreviousPage } from '@hooks/useNeedCardDetails';
import { NEW_HBS_LOGO } from '@lib/context/themes';
import Header from '@components/Layouts/Header/Header';
import BackButton from '@components/UI/BackButton/BackButton';
import Assessment from '@components/Clinicians/Assessment';

const StyledAssessmentContainer = styled.div`
  margin-bottom: 4em;

  .sv_main input[type='button'],
  .sv_main button {
    min-width: 125px !important;
  }

  .sv-action-bar {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    margin: auto;
  }

  .sd-file__drag-area > .sv-action-bar {
    grid-template-columns: repeat(3, 1fr);

    .sv-action {
      display: flex;
      justify-content: center;
    }
  }

  .sv-page {
    margin: 0;
  }

  .sv-action {
    padding-top: 25px;
    padding-bottom: 25px;
    text-align: center;

    .sv-btn {
      min-width: 150px;
      max-width: 150px;
      text-align: center;
    }
  }

  #sv-nav-start {
    grid-column: 1;
    grid-row: 1;
  }

  #sv-nav-prev {
    grid-column: 1;
    grid-row: 1;
  }

  #sv-nav-preview {
    grid-column: 4;
    grid-row: 1;
  }

  #sv-nav-next {
    grid-column: 5;
    grid-row: 1;
  }

  #sv-nav-complete {
    grid-column: 5;
    grid-row: 1;
  }

  .powered-by {
    float: right;
    height: 55px;

    @media (max-width: 600px) {
      height: 45px;
    }
  }

  input[type='date'],
  input[type='datetime-local'],
  input[type='month'],
  input[type='time'] {
    -webkit-appearance: none;
  }

  .sd-btn--action:focus-visible {
    outline: 2px solid var(--productPrimary);
    outline-offset: 4px;
  }

  .sd-scrollable-container:not(.sd-scrollable-container--compact) {
    width: unset;
  }

  .sd-rating fieldset {
    flex-wrap: wrap;
  }
`;

const Assessments = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const dispatch = useDispatch();
  const { surveyjs_id, previous: previousPageParam } = router.query;
  const previousPage = isSurveyPreviousPage(previousPageParam) ? `/patients/${previousPageParam}` : '/patients';
  const initialised = useInitialisedStore();
  const { user } = useAuth();
  // const { showNeedCardDetailsModal } = useNeedCardDetails();
  const cookiesArticle = useArticleWrapped('cookies');
  const [showCookieSettings, setShowCookieSettings] = useState(false);

  const {
    isLoading,
    data: surveyRes,
    refetch
  } = useQuery({
    queryKey: ['getAssessmentSurvey', surveyjs_id],
    queryFn: async () => {
      const res = await dispatch(getAssessmentSurvey({ surveyjs_id: Number(surveyjs_id) }));
      return res.user_surveyjs[0];
    },
    enabled: !!user && !!surveyjs_id
  });

  const { data: survey } = useQuery({
    queryKey: ['allSurveys', surveyRes?.case_id],
    queryFn: async () => {
      const { surveys } = await dispatch(actions.allSurveys({ case_id: surveyRes?.case_id || undefined }));
      return surveys.find(({ survey_id }: { survey_id: number }) => {
        return survey_id === Number(surveyjs_id);
      });
    },
    enabled: !!surveyRes?.case_id
  });

  // const needsCardDetails = !surveyRes?.completed_flag && survey?.card_details_mandatory;
  const [caseDetails] = useCase(surveyRes?.case_id);

  /*
  'docman_consent_required' covers the following conditions to display the modal:
  is DOCMAN active
  does GP accept Docman
  is not NHS client
  is a case level survey
  is answer to consent 'no'
    - we use this with docman_consent_date to no longer display the modal
      if any answer was given

 - The case data is used instead of the survey data to work out if the consent
   modal should be displayed *before* opening the survey.
 - The survey data will only update if the survey is opened - this will
   cause the modal to appear and disappear initially if an answer was already given
  */
  const showDocmanConsentModal =
    caseDetails?.docman_consent_required &&
    !caseDetails?.docman_consent_date &&
    !user?.restricted &&
    !caseDetails?.docman_invalid_gp;

  // useEffect(() => {
  //   if (!surveyRes || !survey) return;

  //   showNeedCardDetailsModal(parseInt(surveyjs_id as string), needsCardDetails);
  // }, [showNeedCardDetailsModal, surveyRes, surveyjs_id, needsCardDetails, survey]);

  const acceptCookies = (cookies?: string[]) => {
    if (cookies) {
      localStorage.setItem('cookie-consent', cookies.map((cookie) => cookie.substring(0, 3)).join(' '));
      setShowCookieSettings(false);
    } else {
      localStorage.setItem('cookie-consent', 'all');
      setShowCookieSettings(false);
    }
    window.location.reload();
  };

  if (!initialised && !survey) {
    return <p>{t('Initialising ...')}</p>;
  }

  return (
    <div>
      <Header pageType="patients" />

      <section className="section-layout patient" id="page-content">
        {surveyRes?.surveyjs_def_id && (
          <StyledAssessmentContainer
            className="container"
            // css={css`
            //   filter: ${needsCardDetails ? 'blur(10px)' : ''};
            // `}
          >
            {user?.user_subtype_code !== 'RESTRICTED' ? (
              <img src={NEW_HBS_LOGO} alt={t('Powered by Lucy')} className="powered-by" />
            ) : null}
            <BackButton text="Back" arrow onClick={() => router.push(previousPage)} data-testid="back-button" />
            <Assessment
              isLoadingSurveyRes={isLoading}
              surveyRes={surveyRes}
              pageType="patients"
              clearCacheOnSuccess
              refetch={refetch}
              showCookieSettings={() => setShowCookieSettings(true)}
            />

            {showDocmanConsentModal && (
              <GetDocmanConsentForm
                isOpen={showDocmanConsentModal}
                caseName={surveyRes?.cat_name}
                caseId={surveyRes?.case_id}
                surveyjsId={surveyRes?.surveyjs_id}
                userGuid={user?.user_guid}
                onCancel={() => {
                  router.push(previousPage);
                }}
              />
            )}

            {showCookieSettings && (
              <CookieSettings
                setSettingsOpen={setShowCookieSettings}
                acceptCookies={acceptCookies}
                setBannerOpen={() => {}}
                article={cookiesArticle}
              />
            )}
          </StyledAssessmentContainer>
        )}
      </section>
    </div>
  );
};


export const Route = createFileRoute('/patients/assessments')({ component: Assessments });
